import { Country } from 'entities/countries/model/types';
import { createSelector, createSlice, PayloadAction } from '@reduxjs/toolkit';
import { PURGE } from 'redux-persist';
import { RootState } from 'shared/config/store/store';

export type CountriesReducer = {
  countries: Country[];
};

const initialState: CountriesReducer = {
  countries: [],
};

const countriesSlice = createSlice({
  name: 'countries',
  initialState,
  reducers: {
    setCountries(state, action: PayloadAction<Country[]>) {
      state.countries = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(PURGE, () => initialState);
  },
});

export const { setCountries } = countriesSlice.actions;
export default countriesSlice.reducer;

const selectCountriesState = (state: RootState) => state.countries;

export const getCountries = createSelector(
  [selectCountriesState],
  (countries) => countries.countries,
);
export const getEnrollCountries = createSelector([selectCountriesState], (countries) =>
  countries.countries.filter((c: Country) => c.enroll),
);
